<template>
  <div style="position: relative; padding: 0px 0 100px">
    <v-premium-plan-popup
      :showAll="false"
      marginTop="65"
      v-if="$store.getters.getPackage != 'premium'"
      style="border-radius: 5px"
      text="Upgrade to Premium, starting at 500 baht / month to create your campaign with various discount codes. Such as, percentage discount, product discount, and free shipping codes. Upgrade now"
    ></v-premium-plan-popup>
    <v-container>
      <v-layout>
        <v-flex>
          <h2 class="mt-2">
            {{ $t('Coupon') }}
            <a
              href="https://tinyurl.com/2vbz8zsy"
              target="blank"
              ><i style="font-size: 18px; color: #ed1e79" class="fas fa-question-circle"></i
            ></a>
          </h2>
        </v-flex>
        <!-- <v-flex class="text-xs-right">
          <v-btn
            depressed
            color="primary"
            @click="showAdd = true"
            :disabled="coupons.length >= getPackageConfig().couponQuantity"
            ><v-icon>add</v-icon>{{ $t('Add Coupon') }}</v-btn
          >
        </v-flex> -->
      </v-layout>

      <div
        class="spinner text-xs-center"
        style="top: 100px"
        v-if="loading && $store.getters.getPackage == 'premium'"
      >
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
      <template v-else>
        <template v-if="coupons.length == 0">
          <div class="text-xs-center my-4">
            {{ $t('No coupon') }}
          </div>
          <v-layout wrap style="min-height: 320px;">
            <v-flex xs12 sm3 class="mb-2 px-1" style="cursor: pointer">
              <v-card
                class="blankCard"
                min-width="100%"
                min-height="100%"
                @click="showAdd = true"
                :disabled="coupons.length >= getPackageConfig().couponQuantity"
                style="
                  display: flex;
                  align-items: center;
                  background-color: transparent;
                  border: 3px dashed #eee;
                "
              >
                <v-card-text style="display: flex; flex-direction: column; align-items: center">
                  <v-icon>add</v-icon>
                  <p>{{ $t('Add Coupon') }}</p>
                </v-card-text>
              </v-card>
            </v-flex>
            </v-layout>
        </template>
        <template v-else>
          <v-layout wrap>
            <v-flex xs12 sm3 class="mb-2 px-1" style="cursor: pointer">
              <v-card
                class="blankCard"
                min-width="100%"
                min-height="100%"
                @click="showAdd = true"
                :disabled="coupons.length >= getPackageConfig().couponQuantity"
                style="
                  display: flex;
                  align-items: center;
                  background-color: transparent;
                  border: 3px dashed #eee;
                "
              >
                <v-card-text style="display: flex; flex-direction: column; align-items: center">
                  <v-icon>add</v-icon>
                  <p>{{ $t('Add Coupon') }}</p>
                </v-card-text>
              </v-card>
            </v-flex>
            <template v-for="(coupon, cindex) in availableCoupon">
              <v-flex xs12 sm3 class="mb-2 px-1" :key="cindex">
                <v-card>
                  <v-card-text>
                    <v-layout>
                      <v-flex>
                        <div class="caption grey--text lighten-1">{{ coupon.name }}</div>
                        <div class="mb-2 ">
                          {{ $t('Code') }}:
                          <h2
                            class="primary--text"
                            style="text-transform: uppercase"
                          >
                            {{ coupon.code }}
                          </h2>
                        </div>
                      </v-flex>
                      <v-flex>
                        <v-card-text class="text-xs-right" style="padding:0">
                          <v-layout class="ma-1" style="display: flex; justify-content: flex-end;">
                            <toggle-button
                              :value="coupon.status"
                              :sync="true"
                              small
                              @change="onChangeStatus(coupon, $event)"
                              :color="$vuetify.theme.success"
                              :labels="{ checked: 'ON', unchecked: 'OFF' }"
                            />
                          </v-layout>
                          <v-btn
                            small
                            fab
                            flat
                            class="ma-0"
                            v-clipboard:copy="coupon.code"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onCopyError"
                            ><v-icon>content_copy</v-icon></v-btn
                          >
                        </v-card-text>
                      </v-flex>
                    </v-layout>
                    <div class="caption grey--text lighten-1">
                      {{ $t('Start date') }} {{ dateFormat(coupon.startdate) }}
                    </div>
                    <div class="caption grey--text lighten-1">
                      {{ $t('End date') }} {{ dateFormat(coupon.enddate) }}
                    </div>
                    <br/>
                    <div class="caption grey--text lighten-1" v-if="coupon.total_used">
                      {{ $t('promotion_total_used') }} {{ coupon.total_used }}
                    </div>
                    <div class="caption grey--text lighten-1" v-else>
                      {{ $t('promotion_total_used') }} -
                    </div>
                     <div class="caption grey--text lighten-1" v-if="coupon.quantity">
                      {{ $t('promotion_quantity') }} {{ coupon.quantity }}
                    </div>
                     <div class="caption grey--text lighten-1" v-else>
                      {{ $t('promotion_quantity') }} -
                    </div>
                  </v-card-text>
                  <v-divider />
                  <v-card-text>
                    <div class="caption">{{ $t('Minimum purchase of') }}</div>
                    <v-layout>
                      <v-flex xs6>
                        <h2
                          style="font-weight:normal;"
                          :class="{
                            'cyan--text lighten-2': coupon.promotype == 'price',
                            'orange--text lighten-2': coupon.promotype == 'piece'
                          }"
                        >
                          <template v-if="coupon.promotype == 'price'">
                            {{ coupon.promovalue | numberFormat }} {{ $t('Baht') }}
                          </template>
                          <template v-else
                            >{{ coupon.promovalue | numberFormat }} {{ $t('Items') }}</template
                          >
                        </h2>
                      </v-flex>
                      <v-flex xs6>
                        <div class="text-xs-right">
                          <v-btn
                            fab
                            depressed
                            color="primary"
                            outline
                            small
                            class="super-small ma-1"
                            @click="editCoupon(coupon)"
                          >
                            <v-icon style="font-size:16px">edit</v-icon>
                          </v-btn>
                          <v-btn
                            fab
                            depressed
                            color="primary"
                            outline
                            small
                            class="super-small ma-1"
                            @click="onDeleteCoupon(coupon)"
                          >
                            <v-icon style="font-size:16px"> delete </v-icon>
                          </v-btn>
                        </div>
                      </v-flex>
                    </v-layout>
                    <div class="font-weight-bold">
                      <template v-if="coupon.discounttype == 'price'">
                        {{ $t('Discount price') }} {{ coupon.discountvalue | numberFormat }}
                        {{ $t('Baht') }}
                      </template>
                      <template v-else-if="coupon.discounttype == 'percent'">
                        {{ $t('Discount percent') }} {{ coupon.discountvalue }} %
                      </template>
                      <template v-else-if="coupon.discounttype == 'ship'">
                        {{ $t('Discount shipping fee') }} {{ coupon.discountvalue | numberFormat }}
                        {{ $t('Baht') }}
                      </template>
                      <template v-else-if="coupon.discounttype == 'freeship'">
                        {{ $t('Free Delivery') }}
                      </template>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </template>
          </v-layout>
          <v-divider class="my-3" v-if="unavailableCoupon.length > 0" />
          <v-layout wrap>
            <template v-for="(coupon, cindex) in unavailableCoupon">
              <v-flex xs12 sm3 class="mb-2 px-1" :key="cindex">
                <v-card>
                  <v-card-text>
                    <v-layout>
                      <v-flex>
                        <div class="caption grey--text lighten-1">{{ coupon.name }}</div>
                        <div class="mb-2 ">
                          {{ $t('Code') }}:
                          <h2
                            class="primary--text"
                            style="text-transform: uppercase"
                          >
                            {{ coupon.code }}
                          </h2>
                        </div>
                      </v-flex>
                      <v-flex>
                        <v-card-text class="text-xs-right" style="padding:0">
                          <v-layout class="ma-1" style="display: flex; justify-content: flex-end;">
                            <toggle-button
                              :value="coupon.status"
                              :sync="true"
                              small
                              @change="onChangeStatus(coupon, $event)"
                              :color="$vuetify.theme.success"
                              :labels="{ checked: 'ON', unchecked: 'OFF' }"
                            />
                          </v-layout>
                          <v-btn
                            small
                            fab
                            flat
                            class="ma-0"
                            v-clipboard:copy="coupon.code"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onCopyError"
                            ><v-icon>content_copy</v-icon></v-btn
                          >
                        </v-card-text>
                      </v-flex>
                    </v-layout>
                    <div class="caption grey--text lighten-1">
                      {{ $t('Start date') }} {{ dateFormat(coupon.startdate) }}
                    </div>
                    <div class="caption grey--text lighten-1">
                      {{ $t('End date') }} {{ dateFormat(coupon.enddate) }}
                    </div>
                    <br/>
                    <div class="caption grey--text lighten-1" v-if="coupon.total_used">
                      {{ $t('promotion_total_used') }} {{ coupon.total_used }}
                    </div>
                    <div class="caption grey--text lighten-1" v-else>
                      {{ $t('promotion_total_used') }} -
                    </div>
                     <div class="caption grey--text lighten-1" v-if="coupon.quantity">
                      {{ $t('promotion_quantity') }} {{ coupon.quantity }}
                    </div>
                     <div class="caption grey--text lighten-1" v-else>
                      {{ $t('promotion_quantity') }} -
                    </div>
                  </v-card-text>
                  <v-divider />
                  <v-card-text>
                    <div class="caption">{{ $t('Minimum purchase of') }}</div>
                    <v-layout>
                      <v-flex xs6>
                        <h2
                          style="font-weight:normal;"
                          :class="{
                            'cyan--text lighten-2': coupon.promotype == 'price',
                            'orange--text lighten-2': coupon.promotype == 'piece'
                          }"
                        >
                          <template v-if="coupon.promotype == 'price'">
                            {{ coupon.promovalue | numberFormat }} {{ $t('Baht') }}
                          </template>
                          <template v-else
                            >{{ coupon.promovalue | numberFormat }} {{ $t('Items') }}</template
                          >
                        </h2>
                      </v-flex>
                      <v-flex xs6>
                        <div class="text-xs-right">
                          <v-btn
                            fab
                            depressed
                            color="primary"
                            outline
                            small
                            class="super-small ma-1"
                            @click="editCoupon(coupon)"
                          >
                            <v-icon style="font-size:16px">edit</v-icon>
                          </v-btn>
                          <v-btn
                            fab
                            depressed
                            color="primary"
                            outline
                            small
                            class="super-small ma-1"
                            @click="onDeleteCoupon(coupon)"
                          >
                            <v-icon style="font-size:16px"> delete </v-icon>
                          </v-btn>
                        </div>
                      </v-flex>
                    </v-layout>
                    <div class="font-weight-bold">
                      <template v-if="coupon.discounttype == 'price'">
                        {{ $t('Discount price') }} {{ coupon.discountvalue | numberFormat }}
                        {{ $t('Baht') }}
                      </template>
                      <template v-else-if="coupon.discounttype == 'percent'">
                        {{ $t('Discount percent') }} {{ coupon.discountvalue }} %
                      </template>
                      <template v-else-if="coupon.discounttype == 'ship'">
                        {{ $t('Discount shipping fee') }} {{ coupon.discountvalue | numberFormat }}
                        {{ $t('Baht') }}
                      </template>
                      <template v-else-if="coupon.discounttype == 'freeship'">
                        {{ $t('Free Delivery') }}
                      </template>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </template>
          </v-layout>
        </template>
      </template>
      <add-coupon v-model="showAdd" :coupons="coupons" @onsave="onAddCoupon"></add-coupon>
      <template v-if="currentCoupon">
        <add-coupon
          :key="timestamp"
          v-model="showEdit"
          :coupons="coupons"
          :currentcoupon="currentCoupon"
          @onsave="onEditCoupon"
        ></add-coupon>
      </template>
    </v-container>
    <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
      >{{ $t('Code Copied') }}!</v-snackbar
    >
  </div>
</template>

<script>
import api from '@/api'
import AddCoupon from './AddCoupon'
import { ToggleButton } from 'vue-js-toggle-button'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
export default {
  data() {
    return {
      showCopy: false,
      showAdd: false,
      showEdit: false,
      coupons: [],
      loading: false,
      currentCoupon: null,
      timestamp: dayjs().format('x')
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    availableCoupon() {
      if (this.coupons && this.coupons.length > 0)
        return this.coupons.filter(el => el.status === true)
      else return []
    },
    unavailableCoupon() {
      if (this.coupons && this.coupons.length > 0)
        return this.coupons.filter(el => el.status !== true)
      else return []
    }
  },
  components: {
    AddCoupon,
    ToggleButton
  },
  async mounted() {
    var vm = this
    if (vm.selectedBot.theme == 'ecommercebasic') {
      vm.$store.dispatch('loadCategory').then(function() {
        vm.$store.dispatch('loadProducts')
      })
    }
    vm.getPromotioncode()
  },
  methods: {
    async getPromotioncode() {
      const vm = this;
      let response = await vm.getpromotioncode()
      vm.coupons = response.map(el => {
        try {
          let category = []
          try {
            category = el.category !== '[]' ? JSON.parse(el.category) : []
          } catch (error) {}
          return {
            ...el,
            category: category,
            exact_product_ids: el.exact_product_ids ? el.exact_product_ids : null,
            exclude_shipping_list: el.exclude_shipping_list == 'cod_charge' ? true : false,
            quantity:el.quantity ? el.quantity.toString() : null,
            total_used:el.total_used ? el.total_used.toString() : null
          }
        } catch (error) {
          console.error(error)
          return {
            ...el,
            category: [],
            exact_product_ids: null
          }
        }
      })
      vm.sortCoupons()
    },
    getpromotioncode() {
      var vm = this
      vm.loading = true
      var data = {
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getpromotioncode(data, function(error, response) {
          if (error) {
            vm.loading = false
            reject(error)
          }
          if (response.responsecode == 200) {
            vm.loading = false
            resolve(response.data)
          }
        })
      })
    },
    sortCoupons() {
      // this.coupons.sort(function(a, b) {
      //   return a.code > b.code ? 1 : b.code > a.code ? -1 : 0
      // })
      this.coupons.sort((a, b) => b.status - a.status)
    },
    dateFormat(dateTime) {
      return dateTime !== null ? dayjs(dateTime).format('DD/MM/YYYY - HH.mm') : '-'
    },
    async editCoupon(coupon) {
      const vm = this;
      vm.currentCoupon = coupon
      vm.timestamp = dayjs().format('x')
      await vm.$nextTick()
      vm.showEdit = true
    },
    savepromotioncode(coupon) {
      if (coupon.exclude_shipping_list) {
        coupon.exclude_shipping_list = 'cod_charge'
      }
      var data = {
        params: {
          pageid: this.selectedBot.pageid
        },
        data: coupon
      }

      return new Promise((resolve, reject) => {
        api.savepromotioncode(data, function(error, response) {
          if (error) {
            reject(error)
          }

          if (response.responsecode == 200) {
            resolve(response.data)
          }
        })
      })
    },
    async editpromotioncode(coupon) {
      const vm = this;
      if (coupon.exclude_shipping_list) {
        coupon.exclude_shipping_list = 'cod_charge'
      }
      var data = {
        params: {
          pageid: this.selectedBot.pageid
        },
        data: coupon
      }

      return new Promise((resolve, reject) => {
        api.editpromotioncode(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.responsecode == 200) {
            resolve(response.data)
          }
        })
      })
      .then(() => {
     vm.getPromotioncode();
    });
    },


    async onChangeStatus(value, event) {
      this.$store.dispatch('loading')
      try {
        var index = this.coupons.findIndex(el => {
          return el.id == value.id
        })
        this.$set(this.coupons[index], 'status', event.value)
        var response = await this.editpromotioncode(this.coupons[index])

        if (response && response.length > 0) {
          this.$set(this.coupons, index, response[0])
          this.sortCoupons()
        }
      } catch (error) {}
      this.$store.dispatch('loading')
    },
    onCopy() {
      this.showCopy = true
    },
    onCopyError() {},
    async onEditCoupon(payload) {
      this.$store.dispatch('loading')
      try {
        if (payload.id) {
          var index = this.coupons.findIndex(el => {
            return el.id == payload.id
          })
          payload.category = JSON.stringify(payload.category)
          payload.exact_product_ids = payload.exact_product_ids
          var response = await this.editpromotioncode(payload)
          if (response && response.length > 0) {
            this.$set(this.coupons, index, response[0])
            this.sortCoupons()
          }
        }
      } catch (error) {
        this.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          text: `${error}`,
          confirmButtonText: this.$t('Confirm')
        })
        this.getPromotioncode()
      }
      this.currentCoupon = null
      this.$store.dispatch('loading')
    },
    async onAddCoupon(payload) {
      this.$store.dispatch('loading')
      try {
        payload.category = JSON.stringify(payload.category)
        payload.exact_product_ids = payload.exact_product_ids
        var response = await this.savepromotioncode(payload)

        if (response && response.length > 0) {
          this.coupons.push(response[0])
          this.sortCoupons()
        }
      } catch (error) {
        this.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          text: `${error}`,
          confirmButtonText: this.$t('Confirm')
        })
      }
      this.$store.dispatch('loading')
    },
    async onDeleteCoupon(coupon) {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to delete this?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        var index = this.coupons.findIndex(el => {
          return el.id == coupon.id
        })
        if (index != -1) {
          api.deletepromotioncode(
            { id: coupon.id, pageid: this.selectedBot.pageid },
            (error, response) => {
              if (error) {
                return false
              }
              if (response.responsecode == 200) {
              }
            }
          )
          this.coupons.splice(index, 1)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.blankCard {
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Promotion.vue